import Button from '@/components/elements/forms/buttons/Button/Button';
import { LoadingIcon } from '@/components/icons';

type PopupWaitScreenProps = {
  message: string;
  showWindowLabel?: string;
  onShowWindow?: () => void;
  /** Lands initial focus on the show-window button, where the modal around it would not. */
  autoFocusShowWindow?: boolean;
  cancelLabel?: string;
  onCancel?: () => void;
};

const PopupWaitScreen = ({
  message,
  showWindowLabel,
  onShowWindow,
  autoFocusShowWindow,
  cancelLabel,
  onCancel,
}: PopupWaitScreenProps) => (
  <div className="gap-md flex flex-col items-center text-center">
    <LoadingIcon className="h-8 w-8" />
    <p role="status" className="text-fg_primary text-l">
      {message}
    </p>
    {onShowWindow && showWindowLabel && (
      <Button variant="link" size="md" autoFocus={autoFocusShowWindow} onClick={onShowWindow}>
        {showWindowLabel}
      </Button>
    )}
    {onCancel && cancelLabel && (
      <Button variant="link" size="md" onClick={onCancel}>
        {cancelLabel}
      </Button>
    )}
  </div>
);

export default PopupWaitScreen;
